import { useState, useEffect } from "react";
import { countDownStyles } from "../../styles/styles";

export default function CountDown(props) {
  const countDown = countDownStyles().countDown;


  const formatTime = (time) => {
    let seconds = time % 60;
    let minutes = Math.floor(time / 60);

    minutes = minutes.toString().length === 1 ? "0" + minutes : minutes;
    seconds = seconds.toString().length === 1 ? "0" + seconds : seconds;

    return minutes + ":" + seconds;
  };

  

  return <div className={props.countDownStyle ? props.countDownStyle : countDown}>{formatTime(props.time)}</div>;
}
